import { getLayer } from '../layerService.js';

/** One atomic undo entry for a schema-driven object-type conversion. */
export default class ObjectConversionCommand {
    constructor({ objectUuid, beforeConfig, afterConfig, pageUuid, sourceType, targetType }) {
        this.id = crypto.randomUUID();
        this.timestamp = Date.now();
        this.description = `Convert ${sourceType} to ${targetType}`;
        this.category = 'structure';
        this.objectUuid = objectUuid;
        this.affectedUuids = [objectUuid];
        this.pageUuid = pageUuid ?? null;
        this.beforeConfig = beforeConfig;
        this.afterConfig = afterConfig;
    }

    execute() {
        getLayer()?.replaceObjectWithConfig(this.objectUuid, this.afterConfig);
    }

    undo() {
        getLayer()?.replaceObjectWithConfig(this.objectUuid, this.beforeConfig);
    }

    toJSON() {
        return {
            type: 'ObjectConversion',
            id: this.id,
            timestamp: this.timestamp,
            payload: { objectUuid: this.objectUuid, pageUuid: this.pageUuid },
        };
    }
}
